import styled from "styled-components";

export const Container = styled.div`
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  font-family: monospace;
  font-size: 12px;

  & > div {
    margin-bottom: 8px;
    line-height: 1.4;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ErrorContainer = styled.div`
  color: #d32f2f;
  padding: 10px;
  border: 1px solid #d32f2f;
  border-radius: 4px;
  background-color: #ffebee;
`;

export const LoadingContainer = styled.div`
  color: #666;
  font-size: 12px;
  font-style: italic;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
`;

export const NoConfigContainer = styled.div`
  color: #666;
  font-size: 12px;
  font-style: italic;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
`;
